import { UIElement } from "../ui-element.js";
//#region src/ui/volume-indicator/fill.ts
var VolumeIndicatorFillElement = class extends UIElement {
	static {
		this.tagName = "media-volume-indicator-fill";
	}
};
//#endregion
export { VolumeIndicatorFillElement };

//# sourceMappingURL=fill.js.map